<template>
  <div class="app-page-header">
    <h2 v-html="loading ? '' : computedTitle"></h2>
    <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
    <div class="buttons">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-page-header',
  props: ['title', 'loading'],
  computed: {
    computedTitle() {
      const { title } = this;

      return typeof title == 'string'
        ? title
        : title.join(
            '<span class="icon is-small"><i class="mdi mdi-chevron-right"></i></span>'
          );
    },
  },
};
</script>

<style lang="scss" scoped>
.app-page-header {
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 16px;
  border-bottom: 1px solid #d5d5d5;
  padding-bottom: 16px;

  h2 {
    font-size: 1.4em;
    font-weight: 500;

    .icon {
      margin: 0 6px;
    }
  }

  .buttons {
    > * {
      margin-left: 12px;
    }
  }
}
</style>
